const API_URL = process.env.REACT_APP_API_URL
const STORAGE_USER_KEY = "bb-user"
const STORAGE_RECENT_SEARCH_KEY = "bb-recent-search"
const STORAGE_RECENT_ACTIVITY_EVENT_TYPES_KEY =
  "bb-recent-activity-event-types-v1"
const STORAGE_RECENT_ACTIVITY_DATE_RANGE_KEY =
  "bb-recent-activity-date-range-v1"

export const RTK_SLICE_API_LIST = "LIST"
export const BOLD_BI_ROOT_URL = "https://bankingbridge.boldbi.com/bi"
export const BOLD_BI_DASHBOARD_API_URL =
  process.env.REACT_APP_API_HOST + "/api/v1/boldbi-dashboard"
export {
  API_URL,
  STORAGE_USER_KEY,
  STORAGE_RECENT_SEARCH_KEY,
  STORAGE_RECENT_ACTIVITY_EVENT_TYPES_KEY,
  STORAGE_RECENT_ACTIVITY_DATE_RANGE_KEY
}

export const APP_STORE_LINK =
  "https://apps.apple.com/us/app/bankingbridge/id6755360159"
export const ENGAGE_LINK = "https://www.bankingbridge.com/dreamrate"
export const SUPPORT_LINK = "https://bankingbridgesupport.zendesk.com/hc/en-us"
export const EMBED_DOCUMENTATION_LINK =
  "https://bankingbridgesupport.zendesk.com/hc/en-us/articles/33152367547159-bankingbridge-embed"
export const APP_DOWNLOAD_LINK = "https://bbrid.ge/mobile-app"
export const SWAGGER_DOCS_LINK = "https://bbrid.ge/swagger"
export const RATEFLOW_DEV_TOOLS_LINK = "https://rateflow-dev.bbridge.io/"

export const CLASS_NAME_DEFAULT = ""
